import { appWindowError404Icon } from './app-window-error-404';
import { arrowButtonDownIcon } from './arrow-button-down';
import { arrowButtonLeftIcon } from './arrow-button-left';
import { arrowButtonRightIcon } from './arrow-button-right';
import { arrowButtonUpIcon } from './arrow-button-up';
import { arrowDoubleLeftIcon } from './arrow-double-left';
import { arrowDoubleRightIcon } from './arrow-double-right';
import { arrowDownIcon } from './arrow-down';
import { arrowLeftLightIcon } from './arrow-left-light';
import { arrowLeftIcon } from './arrow-left';
import { arrowRightLightIcon } from './arrow-right-light';
import { arrowThickCircleLeftIcon } from './arrow-thick-circle-left';
import { arrowUpIcon } from './arrow-up';
import { assignIcon } from './assign';
import { calendarIcon } from './calendar';
import { canceledCircleIcon } from './canceled-circle';
import { checkmarkThinIcon } from './checkmark-thin';
import { checkmarkIcon } from './checkmark';
import { chevronDownIcon } from './chevron-down';
import { chevronUpIcon } from './chevron-up';
import { clockCircleIcon } from './clock-circle';
import { closeIcon } from './close';
import { codeIcon } from './code';
import { collapseIcon } from './collapse';
import { copyPasteIcon } from './copy-paste';
import { copyIcon } from './copy';
import { costAnalysisIcon } from './cost-analysis';
import { currencyDollarIcon } from './currency-dollar';
import { delete24Icon } from './delete-24';
import { deleteIcon } from './delete';
import { desktopComputerPcIcon } from './desktop-computer-pc';
import { doneCircleBigIcon } from './done-circle-big';
import { doneCircleIcon } from './done-circle';
import { downloadIcon } from './download';
import { dragStartIcon } from './drag-start';
import { edit24Icon } from './edit-24';
import { editIcon } from './edit';
import { emailErrorIcon } from './email-error';
import { emptyIcon } from './empty';
import { errorCircleIcon } from './error-circle';
import { expandIcon } from './expand';
import { externalSystemsIcon } from './external-systems';
import { fileCodeCheckIcon } from './file-code-check';
import { fileIcon } from './file';
import { filterIcon } from './filter';
import { fitToScreenIcon } from './fit-to-screen';
import { headerCloseIcon } from './header-close';
import { highPriorityIcon } from './high-priority';
import { hourglassIcon } from './hourglass';
import { inProgressIcon } from './in-progress';
import { infoLogIcon } from './info-log';
import { informationCircleIcon } from './information-circle';
import { jumpToIcon } from './jump-to';
import { layersStackedIcon } from './layers-stacked';
import { linkIcon } from './link';
import { lockClosedIcon } from './lock-closed';
import { lockOpenIcon } from './lock-open';
import { lockIcon } from './lock';
import { lowPriorityIcon } from './low-priority';
import { mediumPriorityIcon } from './medium-priority';
import { menuDotsIcon } from './menu-dots';
import { messagesBubleAddIcon } from './messages-buble-add';
import { navigationRightCircle1Icon } from './navigation-right-circle-1';
import { newEmailIcon } from './new-email';
import { noConnectionCircleIcon } from './no-connection-circle';
import { noConnectionIcon } from './no-connection';
import { noDataIcon } from './no-data';
import { organizationIcon } from './organization';
import { parametersIcon } from './parameters';
import { pasteIcon } from './paste';
import { pdfIcon } from './pdf';
import { pinIcon } from './pin';
import { playLightIcon } from './play-light';
import { playOutlinedIcon } from './play-outlined';
import { playIcon } from './play';
import { plusIcon } from './plus';
import { powerOffIcon } from './power-off';
import { powerOnIcon } from './power-on';
import { questionmarkIcon } from './questionmark';
import { refreshIcon } from './refresh';
import { removeCircleIcon } from './remove-circle';
import { renameIcon } from './rename';
import { repeatIcon } from './repeat';
import { resourceLoginIcon } from './resource-login';
import { resourceLogoutIcon } from './resource-logout';
import { resourceIcon } from './resource';
import { restartIcon } from './restart';
import { revertIcon } from './revert';
import { searchIcon } from './search';
import { sendEmailFlyIcon } from './send-email-fly';
import { sendEmailIcon } from './send-email';
import { sequenceIcon } from './sequence';
import { serverError500Icon } from './server-error-500';
import { sessionListIcon } from './session-list';
import { sessionsIcon } from './sessions';
import { settingsIcon } from './settings';
import { shrinkIcon } from './shrink';
import { simpleIcon } from './simple';
import { sortIcon } from './sort';
import { stopIcon } from './stop';
import { subtractCircleIcon } from './subtract-circle';
import { tagIcon } from './tag';
import { timeIcon } from './time';
import { timerIcon } from './timer';
import { unpinIcon } from './unpin';
import { uploadedCircleIcon } from './uploaded-circle';
import { uploadedIcon } from './uploaded';
import { viewOff2Icon } from './view-off-2';
import { viewOffIcon } from './view-off';
import { viewSolidIcon } from './view-solid';
import { viewIcon } from './view';
import { waitingIcon } from './waiting';
import { warningCircleIcon } from './warning-circle';
import { warningTriangleIcon } from './warning-triangle';
import { webhookIcon } from './webhook';
import { zoomInIcon } from './zoom-in';
import { zoomOutIcon } from './zoom-out';
export const sharedIcons = [appWindowError404Icon, arrowButtonDownIcon, arrowButtonLeftIcon, arrowButtonRightIcon, arrowButtonUpIcon, arrowDoubleLeftIcon, arrowDoubleRightIcon, arrowDownIcon, arrowLeftLightIcon, arrowLeftIcon, arrowRightLightIcon, arrowThickCircleLeftIcon, arrowUpIcon, assignIcon, calendarIcon, canceledCircleIcon, checkmarkThinIcon, checkmarkIcon, chevronDownIcon, chevronUpIcon, clockCircleIcon, closeIcon, codeIcon, collapseIcon, copyPasteIcon, copyIcon, costAnalysisIcon, currencyDollarIcon, delete24Icon, deleteIcon, desktopComputerPcIcon, doneCircleBigIcon, doneCircleIcon, downloadIcon, dragStartIcon, edit24Icon, editIcon, emailErrorIcon, emptyIcon, errorCircleIcon, expandIcon, externalSystemsIcon, fileCodeCheckIcon, fileIcon, filterIcon, fitToScreenIcon, headerCloseIcon, highPriorityIcon, hourglassIcon, inProgressIcon, infoLogIcon, informationCircleIcon, jumpToIcon, layersStackedIcon, linkIcon, lockClosedIcon, lockOpenIcon, lockIcon, lowPriorityIcon, mediumPriorityIcon, menuDotsIcon, messagesBubleAddIcon, navigationRightCircle1Icon, newEmailIcon, noConnectionCircleIcon, noConnectionIcon, noDataIcon, organizationIcon, parametersIcon, pasteIcon, pdfIcon, pinIcon, playLightIcon, playOutlinedIcon, playIcon, plusIcon, powerOffIcon, powerOnIcon, questionmarkIcon, refreshIcon, removeCircleIcon, renameIcon, repeatIcon, resourceLoginIcon, resourceLogoutIcon, resourceIcon, restartIcon, revertIcon, searchIcon, sendEmailFlyIcon, sendEmailIcon, sequenceIcon, serverError500Icon, sessionListIcon, sessionsIcon, settingsIcon, shrinkIcon, simpleIcon, sortIcon, stopIcon, subtractCircleIcon, tagIcon, timeIcon, timerIcon, unpinIcon, uploadedCircleIcon, uploadedIcon, viewOff2Icon, viewOffIcon, viewSolidIcon, viewIcon, waitingIcon, warningCircleIcon, warningTriangleIcon, webhookIcon, zoomInIcon, zoomOutIcon];
